import actionTypes from './actionTypes';

export const changeProofOfOwnerToggle = payload => ({
	type: actionTypes.TOGGLE_CHANGED,
	payload
});


// WEBPACK FOOTER //
// ./src/modules/account-connector/components/proof-of-ownership-mobile/actions.js